import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/layouts/MenuView'
import Login from '@/pages/login/Login'
import not from '@/pages/exception/404'
import error from '@/pages/exception/500'
import dashboard from '@/pages/dashboard/WorkPlace'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
export function constantRouterMap () {
  return [
    {
      path: '/login',
      name: '登录页',
      component: Login,
      invisible: true
    },
    {
      path: '/500',
      component: error,
      invisible: true
    },
    {
      path: '/',
      name: 'home',
      component: MenuView,
      redirect: '/dashboard/workplace',
      icon: 'home',
      // invisible: true,
      children: [
        {
          path: '/dashboard/workplace',
          name: '首页',
          component: dashboard,
          icon: 'home'
        }]
    },
    {
      path: '*',
      component: not,
      invisible: true
    }
  ]
}
export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap()
})



// WEBPACK FOOTER //
// ./src/router/lazy.js